import React from 'react';
import { Platform, SafeAreaView } from 'react-native';
import { SafeAreaView as SafeAreaViewAndroid } from 'react-native-safe-area-context';

const SafeArea = (props) => {
  if (Platform.OS === 'android'){
    return (
      <SafeAreaViewAndroid {...props} >
        {props.children}
      </SafeAreaViewAndroid>
    )
  }
  return (
    <SafeAreaView {...props} >
      {props.children}
    </SafeAreaView>
  )
};

export default SafeArea;